import React from 'react';
import { X, Megaphone, Heart, Moon, Gift, Sparkles } from 'lucide-react';
import './AnnouncementBanner.css';

// Theme configurations with colors
const THEME_CONFIG = {
  NEUTRAL: { colors: ['#0d7463', '#059669'], textColor: 'white', icon: Megaphone },
  VALENTINES: { colors: ['#ec4899', '#db2777'], textColor: 'white', icon: Heart },
  RAMADAN: { colors: ['#7c3aed', '#5b21b6'], textColor: 'white', icon: Moon },
  CHRISTMAS: { colors: ['#dc2626', '#16a34a'], textColor: 'white', icon: Gift },
  EASTER: { colors: ['#f472b6', '#a855f7'], textColor: 'white', icon: Sparkles },
  NEW_YEAR: { colors: ['#fbbf24', '#f59e0b'], textColor: '#1f2937', icon: Sparkles }
};

// Decorative SVG patterns for each theme
const ThemeDecorations = ({ theme }) => {
  switch (theme) {
    case 'VALENTINES':
      return (
        <div className="announcement-decor announcement-decor-valentines">
          <svg className="decor-left" viewBox="0 0 80 80" fill="none">
            <path d="M40 70C40 70 10 45 10 25C10 10 25 5 40 20C55 5 70 10 70 25C70 45 40 70 40 70Z" fill="currentColor" opacity="0.15"/>
          </svg>
          <svg className="decor-right" viewBox="0 0 60 60" fill="none">
            <path d="M30 55C30 55 5 35 5 18C5 6 18 2 30 15C42 2 55 6 55 18C55 35 30 55 30 55Z" fill="currentColor" opacity="0.12"/>
          </svg>
          <svg className="decor-scatter decor-scatter-1" viewBox="0 0 24 24" fill="none">
            <path d="M12 21C12 21 3 14 3 8C3 4 7 2 12 7C17 2 21 4 21 8C21 14 12 21 12 21Z" fill="currentColor" opacity="0.2"/>
          </svg>
          <svg className="decor-scatter decor-scatter-2" viewBox="0 0 20 20" fill="none">
            <path d="M10 18C10 18 2 12 2 7C2 3 6 1 10 6C14 1 18 3 18 7C18 12 10 18 10 18Z" fill="currentColor" opacity="0.15"/>
          </svg>
        </div>
      );

    case 'RAMADAN':
      return (
        <div className="announcement-decor announcement-decor-ramadan">
          <svg className="decor-left" viewBox="0 0 80 80" fill="none">
            <path d="M60 40C60 55 48 68 33 68C18 68 6 55 6 40C6 25 18 12 33 12C20 20 15 35 22 50C29 58 42 58 52 48C58 42 60 35 60 40Z" fill="currentColor" opacity="0.15"/>
            <circle cx="55" cy="18" r="4" fill="currentColor" opacity="0.2"/>
          </svg>
          <svg className="decor-right" viewBox="0 0 60 60" fill="none">
            <path d="M45 30C45 42 36 52 25 52C14 52 5 42 5 30C5 18 14 8 25 8C15 14 11 26 17 38C22 44 32 44 40 36C44 32 45 26 45 30Z" fill="currentColor" opacity="0.12"/>
            <circle cx="48" cy="12" r="3" fill="currentColor" opacity="0.18"/>
          </svg>
          <svg className="decor-scatter decor-scatter-1" viewBox="0 0 16 16" fill="none">
            <polygon points="8,0 10,6 16,6 11,10 13,16 8,12 3,16 5,10 0,6 6,6" fill="currentColor" opacity="0.2"/>
          </svg>
        </div>
      );

    case 'CHRISTMAS':
      return (
        <div className="announcement-decor announcement-decor-christmas">
          <svg className="decor-left" viewBox="0 0 80 80" fill="none">
            <path d="M40 5L45 25H65L49 38L55 58L40 45L25 58L31 38L15 25H35L40 5Z" fill="currentColor" opacity="0.12"/>
          </svg>
          <svg className="decor-right" viewBox="0 0 60 60" fill="none">
            <circle cx="30" cy="30" r="8" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.15"/>
            <circle cx="30" cy="30" r="15" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.1"/>
            <circle cx="30" cy="30" r="22" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.08"/>
          </svg>
          <svg className="decor-scatter decor-scatter-1" viewBox="0 0 20 20" fill="none">
            <path d="M10 0L11.5 8.5L20 10L11.5 11.5L10 20L8.5 11.5L0 10L8.5 8.5L10 0Z" fill="currentColor" opacity="0.18"/>
          </svg>
          <svg className="decor-scatter decor-scatter-2" viewBox="0 0 16 16" fill="none">
            <path d="M8 0L9 7L16 8L9 9L8 16L7 9L0 8L7 7L8 0Z" fill="currentColor" opacity="0.15"/>
          </svg>
        </div>
      );

    case 'EASTER':
      return (
        <div className="announcement-decor announcement-decor-easter">
          <svg className="decor-left" viewBox="0 0 80 80" fill="none">
            <ellipse cx="40" cy="45" rx="22" ry="28" fill="currentColor" opacity="0.1"/>
            <path d="M25 35C25 35 30 30 40 30C50 30 55 35 55 35" stroke="currentColor" strokeWidth="2" opacity="0.15" fill="none"/>
            <path d="M28 45C28 45 32 42 40 42C48 42 52 45 52 45" stroke="currentColor" strokeWidth="2" opacity="0.12" fill="none"/>
          </svg>
          <svg className="decor-right" viewBox="0 0 60 60" fill="none">
            <ellipse cx="30" cy="35" rx="16" ry="20" fill="currentColor" opacity="0.08"/>
            <circle cx="22" cy="30" r="3" fill="currentColor" opacity="0.15"/>
            <circle cx="38" cy="32" r="2.5" fill="currentColor" opacity="0.12"/>
            <circle cx="30" cy="40" r="2" fill="currentColor" opacity="0.18"/>
          </svg>
          <svg className="decor-scatter decor-scatter-1" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="4" fill="currentColor" opacity="0.15"/>
          </svg>
        </div>
      );

    case 'NEW_YEAR':
      return (
        <div className="announcement-decor announcement-decor-newyear">
          <svg className="decor-left" viewBox="0 0 80 80" fill="none">
            <path d="M20 60L25 40L10 25L30 28L40 10L50 28L70 25L55 40L60 60L40 50L20 60Z" fill="currentColor" opacity="0.12"/>
          </svg>
          <svg className="decor-right" viewBox="0 0 60 60" fill="none">
            <circle cx="30" cy="30" r="5" fill="currentColor" opacity="0.15"/>
            <circle cx="30" cy="30" r="12" fill="none" stroke="currentColor" strokeWidth="1" strokeDasharray="4 3" opacity="0.2"/>
            <circle cx="30" cy="30" r="20" fill="none" stroke="currentColor" strokeWidth="1" strokeDasharray="2 4" opacity="0.12"/>
          </svg>
          <svg className="decor-scatter decor-scatter-1" viewBox="0 0 16 16" fill="none">
            <polygon points="8,0 10,6 16,6 11,10 13,16 8,12 3,16 5,10 0,6 6,6" fill="currentColor" opacity="0.2"/>
          </svg>
          <svg className="decor-scatter decor-scatter-2" viewBox="0 0 12 12" fill="none">
            <polygon points="6,0 7.5,4.5 12,4.5 8.5,7.5 10,12 6,9 2,12 3.5,7.5 0,4.5 4.5,4.5" fill="currentColor" opacity="0.15"/>
          </svg>
        </div>
      );

    case 'NEUTRAL':
    default:
      return (
        <div className="announcement-decor announcement-decor-neutral">
          <svg className="decor-left" viewBox="0 0 80 80" fill="none">
            <circle cx="25" cy="40" r="20" fill="currentColor" opacity="0.08"/>
            <circle cx="55" cy="55" r="12" fill="currentColor" opacity="0.06"/>
          </svg>
          <svg className="decor-right" viewBox="0 0 60 60" fill="none">
            <circle cx="40" cy="30" r="18" fill="currentColor" opacity="0.07"/>
            <circle cx="15" cy="45" r="10" fill="currentColor" opacity="0.05"/>
          </svg>
        </div>
      );
  }
};

export default function AnnouncementBanner({ announcement, onDismiss, onButtonClick }) {
  if (!announcement) return null;

  const theme = THEME_CONFIG[announcement.theme] || THEME_CONFIG.NEUTRAL;
  const Icon = theme.icon;

  const handleButtonClick = (e) => {
    // Track the click
    if (onButtonClick) {
      onButtonClick(announcement.id);
    }
    // Open the URL
    if (announcement.buttonUrl) {
      window.open(announcement.buttonUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss(announcement.id);
    }
  };

  return (
    <div
      className={`announcement-banner announcement-theme-${(announcement.theme || 'NEUTRAL').toLowerCase()}`}
      style={{
        background: `linear-gradient(135deg, ${theme.colors[0]} 0%, ${theme.colors[1]} 100%)`,
        color: theme.textColor
      }}
    >
      {/* Decorative overlay */}
      <ThemeDecorations theme={announcement.theme || 'NEUTRAL'} />

      {/* Shimmer effect */}
      <div className="announcement-shimmer" />

      <div className="announcement-content">
        {announcement.imageUrl ? (
          <img
            src={announcement.imageUrl}
            alt=""
            className="announcement-image"
          />
        ) : (
          <div className="announcement-icon">
            <Icon size={20} />
          </div>
        )}

        <div className="announcement-text">
          <span className="announcement-title">{announcement.title}</span>
          <span className="announcement-message">{announcement.message}</span>
        </div>

        {announcement.buttonUrl && (
          <button
            className="announcement-btn"
            onClick={handleButtonClick}
            style={{ color: theme.textColor }}
          >
            {announcement.buttonText || 'Learn More'}
          </button>
        )}

        <button
          className="announcement-close"
          onClick={handleDismiss}
          aria-label="Dismiss announcement"
          style={{ color: theme.textColor }}
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
